export function deleteRefill(budget: Budget, refill: RecordEntry): Budget {
  const initial = budget.initial - refill.amount;
  return {...budget, initial};
}
